import React, { useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

const DynamicThemeProvider = ({ children }) => {
    useEffect(() => {
        const docRef = doc(db, "siteContent", "main");
        const unsubscribe = onSnapshot(docRef, (doc) => {
            if (doc.exists()) {
                const data = doc.data();
                const root = document.documentElement;
                root.style.setProperty('--color-primary', data.primaryColor || '#d97706');
                root.style.setProperty('--color-button', data.buttonColor || '#d97706');
                root.style.setProperty('--color-button-text', data.buttonTextColor || '#000000');
                root.style.setProperty('--color-background', data.backgroundColor || '#171717');
                root.style.setProperty('--color-text', data.textColor || '#e5e5e5');
            }
        });
        return () => unsubscribe();
    }, []);
    return <>{children}</>;
};
export default DynamicThemeProvider;